import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../../main';
import { toast } from 'react-toastify';
import { 
    fetchPagos,
    fetchPagosBySuscripcion,
    fetchPagosGroupedByMonthAndYear,
    createPago,
    createMultiplePagos,
    updatePago,
    deletePago
} from '../api/pagoService';
import { useTenantCode } from './useTenantCode';


// Query hook para obtener todos los pagos
export const usePagosQuery = () => {
    const tenantCode = useTenantCode();
    return useQuery({
        queryKey: ['pagos', tenantCode],
        queryFn: fetchPagos
    });
};

// Query hook para obtener pagos por suscripción
export const usePagosBySuscripcionQuery = (suscripcion_id: string) => {
    const tenantCode = useTenantCode();
    return useQuery({
        queryKey: ['pagos', suscripcion_id, tenantCode],
        queryFn: () => fetchPagosBySuscripcion(suscripcion_id),
        enabled: !!suscripcion_id
    });
};

// Query hook para obtener pagos agrupados por mes y año
export const usePagosGroupedByMonthAndYearQuery = () => {
    const tenantCode = useTenantCode();
    return useQuery({
        queryKey: ['pagos', 'grouped', tenantCode],
        queryFn: fetchPagosGroupedByMonthAndYear
    });
};

// Mutación para crear un pago
export const useCreatePagoMutation = () => useMutation({
    mutationFn: createPago,
    onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['pagos'] });
        toast.success('Pago creado exitosamente');
    },
    onError: () => {
        toast.error('Error al crear el pago');
    }
});

// Mutación para crear múltiples pagos
export const useCreateMultiplePagosMutation = () => useMutation({
    mutationFn: createMultiplePagos,
    onSuccess: (data, variables) => {
        queryClient.invalidateQueries({ queryKey: ['pagos'] });
        queryClient.invalidateQueries({ queryKey: ['pagos', variables.suscripcion_id] });
        toast.success('Pagos creados exitosamente');
    },
    onError: () => {
        toast.error('Error al crear los pagos');
    }
});

// Mutación para actualizar un pago
export const useUpdatePagoMutation = () => useMutation({
    mutationFn: updatePago,
    onSuccess: (data) => {
        queryClient.invalidateQueries({ queryKey: ['pagos'] });
        if (typeof data.suscripcion_id === 'string') {
            queryClient.invalidateQueries({ queryKey: ['pagos', data.suscripcion_id] });
        }
        toast.success('Pago actualizado exitosamente');
    },
    onError: () => {
        toast.error('Error al actualizar el pago');
    }
});

// Mutación para eliminar un pago
export const useDeletePagoMutation = () => useMutation({
    mutationFn: deletePago,
    onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['pagos'] });
        toast.success('Pago eliminado exitosamente');
    },
    onError: () => {
        toast.error('Error al eliminar el pago');
    }
});